import { useEffect, useState } from 'react';
import { ProjectLinkPopup } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/ProjectLinksField/ProjectLinkPopup/ProjectLinkPopup';
import { DeleteProjectLinkPopup } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/ProjectLinksField/DeleteProjectLinkPopup/DeleteProjectLinkPopup';
import type { PersonaFieldProps } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/personaFieldProps';
import type { ProjectLink } from 'src/pages/ConfigurationPage/utils/getPersonaFormValues';

export const ProjectLinksField = ({
  field,
  data,
  setValue,
  readonly,
  value,
}: Omit<PersonaFieldProps<'pf_pages'>, 'control' | 'watch'> & {
  value: ProjectLink[];
}) => {
  const [links, setLinks] = useState<ProjectLink[]>([]);

  useEffect(() => {
    if (readonly) {
      if (data) {
        return setLinks(data);
      }
      return setLinks([]);
    }

    if (value) {
      return setLinks(value);
    }

    if (data) {
      return setLinks(data);
    }

    setLinks([]);
  }, [data, readonly]);

  useEffect(() => {
    if (links?.length) {
      return setValue('pf_pages', links);
    }

    setValue('pf_pages', []);
  }, [links]);

  const addProjectLink = (data: ProjectLink) => {
    setLinks([...links, data]);
  };

  const editProjectLink = (data: ProjectLink, index: number) => {
    links[index] = data;

    setLinks([...links]);
  };

  const deleteProjectLink = (index: number) => {
    const newLinks = [...links];

    newLinks.splice(index, 1);
    setLinks(newLinks);
  };

  return field ? (
    <div className={'flex flex-col w-full gap-2.5'}>
      {Boolean(links?.length) && (
        <div className={'text-ebony_opacity_50 font-medium text-xs'}>Project links</div>
      )}
      <div>
        {links.map((link, index) => {
          return (
            <div
              key={link.pf_page_name}
              className={
                'flex flex-row w-full justify-between py-2.5 pl-3.5 border-b border-b-[#E3E6E8]'
              }
            >
              <div>
                <p className={'text-ebony_opacity_80 text-sm font-medium'}>{link.pf_page_name}</p>
              </div>
              {!readonly && (
                <div className={'flex flex-row gap-5 items-center'}>
                  <ProjectLinkPopup
                    link={link}
                    editProjectLink={(data) => editProjectLink(data, index)}
                  />
                  <DeleteProjectLinkPopup
                    link={link}
                    deleteProjectLink={() => deleteProjectLink(index)}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {!readonly && (
        <div>
          <ProjectLinkPopup addProjectLink={addProjectLink} />
        </div>
      )}
    </div>
  ) : null;
};
